import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from './lib/auth.js';

/**
 * App shell — the persistent layout around routed pages.
 *
 * Surface concerns only (FOLDER_STRUCTURE.md): chrome, routing boundaries.
 * Shows auth state and a logout button when authenticated.
 */
export function App(): JSX.Element {
  const { user, loading, error, signOut } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <div className="app-shell">
      <header className="app-header">
        <span className="app-brand">Breathly</span>
        <div className="app-header-actions">
          {!loading && user && (
            <button className="logout-btn" onClick={handleLogout}>
              Sign out
            </button>
          )}
        </div>
      </header>
      <main className="app-main">
        {error ? (
          <section className="dashboard">
            <div className="dashboard-error">{error}</div>
          </section>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
}
